import type { IconProps } from '../types/IconProps.ts';
export const CircleChevronDown: IconProps = {
    name: 'CircleChevronDown',
    children: [
        `<path d="m8 10 3.76 3.9c.13.13.35.13.48 0L16 10" />`,
        `<circle cx="12" cy="12" r="10" />`,
    ]
};